<template>
  <div class="aw-about">
    <div></div>
    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">我们是谁</p>
        <div class="desc">
          海云捷迅成立于2010年，是国内领先的新质生产力供应商，专注于云计算、人工智能（AI）、物联网（IoT）及边缘计算技术的自主研发与创新。公司以“云+人工智能”为核心，为政府、企业、教育、工业等领域提供全栈式数字化转型解决方案，涵盖智慧政务、智能制造、智算中心、新能源汽车等场景。十余年来，公司秉承开源理念，服务超1万多家企业，助力客户实现IT基础设施现代化与智能化升级。
          <!-- <div class="mt-b"></div>
          主要产品包括：云计算产品、人工智能产品、物联网边缘计算产、教育实训产品、工业检测产品几个方向再过去的十几年间，为高校、科研院所、新媒体、
          医疗、IDC、电力等行业提供适用的服务。并与包括腾讯云、英特尔、SUSE、宝德、锐捷等国内外软硬件厂商及IT服务提供商建立了紧密的战略合作关系，构建了一套完整的开源云服务生态体系。不仅如此，在科技创新上，海云捷迅加大FPGA研发力度，结合自身多年来在开源云计算领域的深耕与贡献，以云+AI产品及服务为FPGA技术及泛人工智能企业，提供辐射全国的技术支持、人才培养、市场推动、品牌推广、渠道与产业对接等全方面服务，进而打造中国FPGA领域的智力高地和产业高地。 -->
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">重点客户</p>
        <img
          class="my-custom-img"
          src="@/assets/about/about_img_logo.png"
          alt=""
        />
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">荣誉与大事记</p>
        <div class="honor_box">
          <div class="timeline">
            <ul class="linelist" :style="{ transform: `translateY(-${activeKey * 84}px)` }">
              <li v-for="(item, index) in honorTitleList" :key="index">
                <span :class="['round', { active: activeKey == index }]"></span>
                <span
                  class="st-line"
                  v-show="index + 1 != honorTitleList.length"
                ></span>
              </li>
            </ul>
            <ul class="honor-title-box" :style="{ transform: `translateY(-${activeKey * 84}px)` }">
              <li
                :class="['honor-title', {active: activeKey == index }]"
                v-for="(item, index) in honorTitleList"
                :key="index"
                @click="handleTitleClick(index)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div class="honor-img-box">
            <ul :style="{ transform: isMobile ?  `translateY(-${Math.floor(activeKey / 4) * 355}px)` : `translateY(-${Math.floor(activeKey / 4) * 372}px)` }">
                 <li><img src="@/assets/honor/honor1.jpg" /></li>
                 <li><img src="@/assets/honor/honor2.jpg" /></li>
                 <li><img src="@/assets/honor/honor3.jpg" /></li>
                 <li><img src="@/assets/honor/honor4.jpg" /></li>
                 <li><img src="@/assets/honor/honor5.jpg" /></li>
                 <li><img src="@/assets/honor/honor6.jpg" /></li>

                 <li><img src="@/assets/honor/honor7.jpg" /></li>
                 <li><img src="@/assets/honor/honor8.jpg" /></li>
                 <li><img src="@/assets/honor/honor9.jpg" /></li>
                 <li><img src="@/assets/honor/honor10.jpg" /></li>
                 <li><img src="@/assets/honor/honor11.jpg" /></li>
                 <li><img src="@/assets/honor/honor12.jpg" /></li>

                 <li><img src="@/assets/honor/honor13.jpg" /></li>
                 <li><img src="@/assets/honor/honor14.jpg" /></li>
                 <li><img src="@/assets/honor/honor15.jpg" /></li>
                 <li><img src="@/assets/honor/honor16.jpg" /></li>
                 <li><img src="@/assets/honor/honor17.jpg" /></li>
                 <li><img src="@/assets/honor/honor18.jpg" /></li>

                 <li><img src="@/assets/honor/honor19.jpg" /></li>
                 <li><img src="@/assets/honor/honor20.jpg" /></li>
                 <li><img src="@/assets/honor/honor1.jpg" /></li>
                 <li><img src="@/assets/honor/honor2.jpg" /></li>
                 <li><img src="@/assets/honor/honor3.jpg" /></li>
                 <li><img src="@/assets/honor/honor4.jpg" /></li>

                 <li><img src="@/assets/honor/honor5.jpg" /></li>
                 <li><img src="@/assets/honor/honor6.jpg" /></li>
                 <li><img src="@/assets/honor/honor7.jpg" /></li>
                 <li><img src="@/assets/honor/honor8.jpg" /></li>
                 <li><img src="@/assets/honor/honor9.jpg" /></li>
                 <li><img src="@/assets/honor/honor10.jpg" /></li>

                 <li><img src="@/assets/honor/honor11.jpg" /></li>
                 <li><img src="@/assets/honor/honor12.jpg" /></li>
                 <li><img src="@/assets/honor/honor13.jpg" /></li>
                 <li><img src="@/assets/honor/honor14.jpg" /></li>
                 <li><img src="@/assets/honor/honor19.jpg" /></li>
                 <li><img src="@/assets/honor/honor20.jpg" /></li>

                 <li><img src="@/assets/honor/honor1.jpg" /></li>
                 <li><img src="@/assets/honor/honor2.jpg" /></li>
                 <li><img src="@/assets/honor/honor3.jpg" /></li>
                 <li><img src="@/assets/honor/honor4.jpg" /></li>
                 <li><img src="@/assets/honor/honor5.jpg" /></li>
                 <li><img src="@/assets/honor/honor6.jpg" /></li>

                 <li><img src="@/assets/honor/honor7.jpg" /></li>
                 <li><img src="@/assets/honor/honor8.jpg" /></li>
                 <li><img src="@/assets/honor/honor9.jpg" /></li>
                 <li><img src="@/assets/honor/honor10.jpg" /></li>
                 <li><img src="@/assets/honor/honor11.jpg" /></li>
                 <li><img src="@/assets/honor/honor12.jpg" /></li>

                 <li><img src="@/assets/honor/honor13.jpg" /></li>
                 <li><img src="@/assets/honor/honor14.jpg" /></li>
                 <li><img src="@/assets/honor/honor15.jpg" /></li>
                 <li><img src="@/assets/honor/honor16.jpg" /></li>
                 <li><img src="@/assets/honor/honor17.jpg" /></li>
                 <li><img src="@/assets/honor/honor18.jpg" /></li>

                 <li><img src="@/assets/honor/honor19.jpg" /></li>
                 <li><img src="@/assets/honor/honor20.jpg" /></li>
                 <li><img src="@/assets/honor/honor1.jpg" /></li>
                 <li><img src="@/assets/honor/honor2.jpg" /></li>
                 <li><img src="@/assets/honor/honor3.jpg" /></li>
                 <li><img src="@/assets/honor/honor4.jpg" /></li>

                 <li><img src="@/assets/honor/honor5.jpg" /></li>
                 <li><img src="@/assets/honor/honor6.jpg" /></li>
                 <li><img src="@/assets/honor/honor7.jpg" /></li>
                 <li><img src="@/assets/honor/honor8.jpg" /></li>
                 <li><img src="@/assets/honor/honor9.jpg" /></li>
                 <li><img src="@/assets/honor/honor10.jpg" /></li>

                 <li><img src="@/assets/honor/honor11.jpg" /></li>
                 <li><img src="@/assets/honor/honor12.jpg" /></li>
                 <li><img src="@/assets/honor/honor13.jpg" /></li>
                 <li><img src="@/assets/honor/honor14.jpg" /></li>
                 <li><img src="@/assets/honor/honor19.jpg" /></li>
                 <li><img src="@/assets/honor/honor20.jpg" /></li>

                 <li><img src="@/assets/honor/honor1.jpg" /></li>
                 <li><img src="@/assets/honor/honor2.jpg" /></li>
                 <li><img src="@/assets/honor/honor3.jpg" /></li>
                 <li><img src="@/assets/honor/honor4.jpg" /></li>
                 <li><img src="@/assets/honor/honor5.jpg" /></li>
                 <li><img src="@/assets/honor/honor6.jpg" /></li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">战略定位</p>
        <ul class="com-purpose-desc">
          <li>
            <img src="@/assets/about/img_fuwuqiye@2x.png" alt="" />
            <!-- <h3>服务企业</h3> -->
            <p>
              资深数字化转型服务商，数字化解决方案专家
            </p>
          </li>
          <li>
            <img src="@/assets/about/img_zhuanzhujishu@2x.png" alt="" />
            <!-- <h3>专注技术</h3> -->
            <p>
              云+AI开源技术践行者，推动技术融合向全场景渗透
            </p>
          </li>
          <li>
            <img src="@/assets/about/img_qinxinpingzhi@2x.png" alt="" />
            <!-- <h3>倾心品质</h3> -->
            <p>
              "云-边-端-链"全栈技术闭环智能基座的构建者
            </p>
          </li>
        </ul>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage my-develop">
        <p class="title">演进历程</p>
        <div class="control-buttons">
          <button class="prev-btn" @click="scrollTimeline('prev')">
            <i class="icon iconfont icon-fj-chevron-left"></i>
          </button>
          <button class="next-btn" @click="scrollTimeline('next')">
            <i class="icon iconfont icon-fj-chevron-right"></i>
          </button>
        </div>
        <div class="develop-box">
          <div class="develop-history">
            <div class="timeline-container">
              <ul class="year-ul" ref="timelineContainer">
                <!-- <li class="consainer-li">
                  <p class="time-title">2024</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2023</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2022</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2021</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2020</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2019</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2018</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li> -->
                <li class="consainer-li">
                  <p class="time-title">2023-2025 | 深化布局</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2020-2022 | 边缘突破</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2017-2019 | 战略升级</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2014-2016 | 生态构建</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
                <li class="consainer-li">
                  <p class="time-title">2010-2013 | 云启航</p>
                  <div class="outer-circle">
                    <div class="inner-circle"></div>
                  </div>
                  <span class="pink-line"></span>
                </li>
              </ul>
              <div class="scoll" ref="textContainer">
                <div class="content">
                  • 推出智能检测平台，布局制造智能化<br />
                  • 深化大模型产品研发，加速构建生态协同全链路创新体系<br />
                </div>
                <div class="content">
                  • AloT解决方案面市<br />
                  • 正式涉猎教育培训领域，获电子标准院人才培养基地认证<br />
                  • 与国内主流软硬件厂商深度适配，部署国产化生态<br />
                </div>
                <div class="content">
                  • "云+AI"双引擎<br />
                  • 超融合产品落地<br />
                </div>
                <div class="content">
                  • 获Intel/腾讯战略投资<br />
                  • 布局SDN/云存储等技术生态<br />
                </div>
                <div class="content">
                  • 成立海云捷迅<br />
                  • 发布Openstack架构的AWCloud云管平台，国内首批自主可控云平台<br />
                </div>
                <!-- <div class="content">
                  •
                  由海云捷迅运营的英特尔FPGA中国创新中心开展2019英特尔®年度工程师培训<br />
                  • 举办"育智芯丨英特尔人工智能解决方案"全国巡展<br />
                  • 与英特尔FPGA中国创新中心联合举办FPGA智能创新国际大赛<br />
                  • 亮相2019中国国际智能产业博览会<br />
                  • 与中科可控、银河麒麟、中标麒麟完成产品兼容性互认证<br />
                  • 推出新品AWCMP大云管平台<br />
                </div>
                <div class="content">
                  • 拥抱RSD架构，加速大规模数据中心落地进程<br />
                  •重庆市政府、英特尔、海云捷迅正式签约，正式运营英特尔FPGA中国创新中心<br />
                </div>
                <div class="content">
                  • 加入"中国人工智能产业创新联盟"<br />
                  • 中标中央国家机关2017年软件协议供货采购项目<br />
                  • 推出AWSTACK超融合水冷一体机<br />
                  • 获得CMMI3<br />
                </div>
                <div class="content">
                  • 发布AWSTACK产品并构建OpenStack核心竞争力<br />
                  • 腾讯云战略投资海云捷迅<br />
                  • 发布容器化SaaS云管模式的产品<br />
                </div>
                <div class="content" id="six">
                  • 获OpenStackDefcore最新标准认证，中国第一，全球第四<br />
                  • 英特尔宣布对AWCloud海云捷迅进行战略投资<br />
                  • 自主研发的新产品超融合一体机，正式对外发布<br />
                  • 云主机服务通过可信云服务权威认证<br />
                  • 成立武汉研发中心<br />
                </div>
                <div class="content">
                  • 与IDC联合运营的云主机规模超过10000台<br />
                  • 与Canonical签署合作协议<br />
                </div>
                <div class="content">
                  • 取得计算机软件著作权登记证书 【AWCloud云计算管理平台】<br />
                  •
                  2011取得北京软件产品登记证书；取得计算机软件著作权（云计算、云存储、云安全、云桌面）<br />
                  • 发布AWCloud云管平台<br />
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="com-desc-box">
      <div class="container-center com-center advantage">
        <p class="title">我们的资质</p>
        <ul class="qyzz">
          <li>
            <img src="@/assets/about/qualification_01.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_02.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_03.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_04.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_05.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_06.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_07.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_08.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_09.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_10.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_11.jpg" />
          </li>
          <li>
            <img src="@/assets/about/qualification_12.jpg" />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentIndex: 0,
      itemWidth: 377, // 每个时间点的宽度
      totalItems: 5,
      visibleItems: 3, // 同时显示的数量
      honorTitleList: [
        "中国新互联网公司300强",
        "2015年中国信息产业年度高成长企业",
        "2015年英特尔超融合产品杰出方案顶级供应商",
        "2016年中国信息技术创新最值得信赖产品",
        "2016年英特尔超融合产品合作伙伴年度风云企业",
        "2016年IT印象企业级云产品创新奖",
        "2017年传媒行业新锐产品奖",
        "2017年教育行业优秀科技产品奖",
        "2017年全国智能医疗大数据创新大赛优秀奖",
        "2017年度中国信息技术创新人工智能领域突出贡献企业奖",
        "2018年十大用户信赖品牌奖",
        "2019年第四届中国优秀云计算开源案例三等奖",
        "2019年度英特尔创新加速器“最佳芯片生态创新合作伙伴”",
        "第八届中国创新创业大赛暨第五届重庆“高新杯”众创大赛荣获“优秀组织奖”",
        "2020年IT用户满意度调查用户首选",
        "2020年度最佳信息化云产品奖",
        "OpenInfra Days China 2021“优秀开源标准化基础设施奖”",
        "2021年中国信创云计算创新企业",
        "中国开放指令生态（RISC-V）联盟2021年会获生态贡献奖",
        "入选北京市 2021 年度第七批拟认定“专精特新”中小企业名单",
        "《2022中国企业数智服务市场趋势洞察报告》发布，海云捷迅入围信创市场高成长象限",
        "2020-2021年中国私有云市场分析报告发布，海云捷迅位列领导者象限",
        '入选2022年重庆市"专精特新"中小企业名单',
        "执行承办第六届全国大学生集成电路创新创业大赛",
        "加入OpenCloudOS操作系统社区",
        "通过教育部产学合作协同育人项目申报",
        '入选"第一批工业和信息化重点领域产业人才基地联合建设机构目录"',
        '入选电子标准院 "电子信息领域人才培养合作单位"',
        "与OpenCloudOS首个社区版本完成兼容性认证",
        "执行承办第七届全国大学生集成电路创新创业大赛",
        "与摩尔线程、广电五舟、数腾软件完成产品兼容互认证",
        "2023年参编的国家级《AI 工业质检应用发展白皮书》并成功发布",
        '承办第七届全国大学生集成电路创新创业大赛 "海云捷迅杯"',
        "参加 2023 中国人工智能大会",
        "受邀出席华为全联接大会 2023",
        '应邀参加以 "致追风赶月的你" 为主题的 2023 甲子引力年终盛典',
        "上榜 2023 OpenCloudOS 社区年度企业贡献榜单",
        "参加 CIE2023 第五届中国 IT 教育博鳌论坛",
        "参加英特尔 FPGA 中国技术日的现场",
        "2024年受邀参加中国通信工业协会教育专委会",
        '应邀参加 2024 世界智能产业博览会，荣获 "Find智能科技创新应用典型案例" 奖项。',
        "入选全国首批数字技术工程师培育项目（云计算技术）考核站点名单",
        "参加第十九届中国国际铝工业展览会",
        '参加中国操作系统产业大会，荣获麒麟软件生态共建"突破创新奖"',
        "参加重庆市科协年会新一代电子信息技术专题学术论坛",
        "入选重庆市 2024 年度制造业数字化转型服务商资源池名单",
        "入选2024 云计算企业 TOP100 榜单",
        "参与一带一路暨金砖国家技能发展国际联盟 2024大数据和人工智能专业委员会国际年会",
        "入选重庆市 2024 年度中小型硬科技企业帮扶库名单",
        "参加中国国际大学生创新大赛（2024）",
        "参加第二十六届中国机器人及人工智能大赛",
        "参加第八届全国大学生集成电路创新创业大赛"
      ],
      activeKey: 0,
      autoPlayTimer: null,
      isMobile:false
    };
  },
  methods: {
    scrollTimeline(direction) {
      if (direction === "prev" && this.currentIndex > 0) {
        this.currentIndex--;
      } else if (
        direction === "next" &&
        this.currentIndex < this.totalItems - this.visibleItems
      ) {
        this.currentIndex++;
      }

      const scrollAmount = this.currentIndex * this.itemWidth;
      this.$refs.timelineContainer.style.transform = `translateX(-${scrollAmount}px)`;
      this.$refs.textContainer.style.transform = `translateX(-${scrollAmount}px)`;
    },


    handleTitleClick(index) {
      this.activeKey = index;
      // 停止当前的自动播放
      this.stopAutoPlay();
      // 重新开始自动播放
      this.startAutoPlay();
    },
    isActive(index) {
      return index >= this.activeKey && index < this.activeKey + 4;
    },
    nextSlide() {
      this.activeKey = this.activeKey < 21 ? this.activeKey + 1 : 0;
    },
    startAutoPlay() {
      this.autoPlayTimer = setInterval(this.nextSlide, 3000);
    },
    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null
      }
    },
  },
  created() {
    this.isMobile = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);    
  },
  mounted() {
    this.startAutoPlay();
  },
  destory() {
    this.stopAutoPlay(); // 组件销毁时清除定时器
  }
};
</script>

<style lang="less" scoped>
.honor_box {
  width: 1200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .timeline {
    display: flex;
    flex-direction: row;
    height: 336px;
    overflow: hidden;
    .linelist {
      margin-right: 20px;
      margin: 24px 20px 0 0;
      li {
        display: flex;
        flex-direction: column;
        align-items: center;
        .round {
          width: 12px;
          height: 12px;
          border-radius: 100%;
          background-color: #e5e5e5;
          &.active {
            background-color: #cc0100;
          }
        }

        .st-line {
          width: 2px;
          height: 72px;
          background-color: #e5e5e5;
        }
      }
    }

    .honor-title-box {
      .honor-title {
        position: relative;
        width: 400px;
        height: 60px;
        box-sizing: border-box;
        margin-bottom: 24px;
        padding: 16px 20px;
        padding-right: 60px;
        clip-path: polygon(93% 1%, 100% 50%, 93% 100%, 0 100%, 0 0);
        background-color: #f3f6f9;
        z-index: 2;
        display: flex;
        align-items: center;
        &.active {
            color: #cc0100;
        }
      }
    }
  }

  .honor-img-box {
    overflow: hidden;
    ul {
      width: 716px;
      height: 348px;
      li {
        width: 216px;
        margin-right: 32px;
        display: inline-block;
        background-color: #ccc;
        margin-bottom: 24px;
        &:nth-of-type(3n) {
          margin-right: 0;
        }
        img {
          width: 216px;
          height: 162px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
    .honor_box {
        width: 100%;
        flex-direction: column;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .timeline {
            display: flex;
            flex-direction: row;
            height: 336px;
            overflow: hidden;
            .linelist {
                margin-right: 20px;
                margin: 24px 20px 0 0;
            li {
                display: flex;
                flex-direction: column;
                align-items: center;
                .round {
                width: 12px;
                height: 12px;
                border-radius: 100%;
                background-color: #e5e5e5;
                &.active {
                    background-color: #cc0100;
                }
                }

                .st-line {
                    width: 2px;
                    height: 72px;
                    background-color: #e5e5e5;
                }
            }
            }

            .honor-title-box {
                .honor-title {
                    position: relative;
                    width: 100%;
                    height: 60px;
                    box-sizing: border-box;
                    margin-bottom: 24px;
                    padding: 16px 20px;
                    padding-right: 60px;
                    clip-path: polygon(93% 1%, 100% 50%, 93% 100%, 0 100%, 0 0);
                    background-color: #f3f6f9;
                    z-index: 2;
                    display: flex;
                    align-items: center;
                    &.active {
                        color: #cc0100;
                    }
                }
            }
        }

        .honor-img-box {
            overflow: hidden;
            ul {
                width: 100%;
                text-align: center;
                height: 355px;
                li {
                    width: 126px;
                    margin-right: 32px;
                    display: inline-block;
                    background-color: #ccc;
                    margin-bottom: 24px;
                    &:nth-of-type(3n) {
                        margin-right: 26px;
                    }
                    &:nth-of-type(2n) {
                        margin-right: 0;
                    }
                    img {
                        width: 126px;
                        height: auto;
                    }
                }
            }
        }
    }
}
</style>
